import { HttpEvent, HttpHandler, HttpHandlerFn, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { LoaderService } from "./loader-service";
import { tap } from "rxjs/operators";
import { inject, Injectable } from "@angular/core";

export function loaderInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    let loaderService = inject(LoaderService);
    loaderService.showLoader();
    return next(req).pipe(tap({
        complete: () => loaderService.hideLoader(),
    }));
}
